import { Molecule, wrap } from "AppReact";
import { Icon, SecondaryTextXlBold, SecondaryTextSmBold, SecondaryTextSm, SecondaryTextLg } from 'atoms';
import { Mt8, Mt3, Width500, TextCenterWrapper } from 'wrappers';
import { MonocleEmojiSvg } from "components/icons";
import getIsMobile from "components/atoms/utils/getIsMobile";
import { SecondaryMessageAtom } from "./secondaryMessageAtom";
import styled from "styled-components";

const isMobile = getIsMobile();

const template = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  cursor: pointer;
`;

export default Molecule({
  template,
  atoms: [
    {
      component: Icon,
      name: "Icon",
      displayValue: ({}) => MonocleEmojiSvg({}),
    },
    {
      component: isMobile
        ? wrap(SecondaryTextSmBold, Mt8)
        : wrap(SecondaryTextXlBold, Mt8),
      name: "Title",
      displayValue: ({ message }) =>
        message ?? `Select a property to see results.`,
    },
    {
      component: isMobile ? wrap(SecondaryTextSm, Mt3) : wrap(wrap(wrap(SecondaryTextLg, Mt3), Width500), TextCenterWrapper),
      name: 'Text',
      renderIf: ({ secondaryText }) => !!secondaryText,
      displayValue: ({ secondaryText }) => secondaryText,
    },
    {
      wrapper: wrap(wrap(Mt3, TextCenterWrapper), Width500),
      name: "NoResultFoundSubTextWrapper",
      renderIf: ({ secondaryMessage }) => !!secondaryMessage,
      atoms: [
        {
          component: SecondaryMessageAtom,
          name: "NoResultFoundSubText",
          displayValue: ({secondaryMessage, buttonText }) => {
            const _onChange = ({ handle }) => {
              handle();
            };
            return {
              color: "#04333B",
              fontWeight: "400",
              fontSize: "20px",
              message: secondaryMessage,
              buttonText,
              _onChange,
              onChangeField: "onClick",
            };
          },
        },
      ],
    },
  ],
});
